// Which of a company's registrar entries is its Companies House or HMRC one, as the lambdas tell it
// (ns-lambda-ts _core/company/registrars.ts): the name AND the registrar type. Other entries' names can be set from a request
// (the bank entry takes the bank's name), so a bank called "HMRC" must never be read as the HMRC entry.

export const REGISTRAR_TYPES = {
  COMPANIES_HOUSE: 'REGISTRATION',
  HMRC: 'TAXATION',
} as const;

export type RegistrarName = keyof typeof REGISTRAR_TYPES;

/** Whether a registrar entry is the company's Companies House (or HMRC) one: that name with that registrar type. */
export function isRegistrar(
  entry: { name?: string | null; registrarType?: string | null } | null | undefined,
  name: RegistrarName,
): boolean {
  return !!entry && entry.name === name && entry.registrarType === REGISTRAR_TYPES[name];
}
